export default {
  SAVE: '/manage/promotionActivity/save',
  FIND_LIST: '/manage/promotionActivity/findList',
  FIND_DETAIL: '/manage/promotionActivity/find',
  DEL: '/manage/promotionActivity/delete'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/promotionActivity.js